<app-pie-chart [data]="devicePieChartData" [height]="'400px'" [fullPie]="true" [colors]="colors"></app-pie-chart>